var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"org-username"},[_c('user-icon',{attrs:{"logoPath":_vm.row.BeUserLogo || _vm.row.UserLogo}}),_c('span',[_vm._v(_vm._s(_vm.row.Name || _vm.row.BeCompName))])],1),(_vm.row.UserID == 0)?_c('span',{staticClass:"org-sub"},[_vm._v("的所有人")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }